import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {delay, map, share, shareReplay, tap} from 'rxjs/operators';
import {Cost} from '../models/cost.model';
import {CostActions} from '../models/cost-action.model';
import {UserService} from './user.service';
import {Attachment} from '../models/attachment.model';
import {IApiDataService, ApiDataOptions} from '../models/api-data.interface';
import {CostHistory} from '../models/cost-history.model';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CostService implements IApiDataService {
  private url = environment.url;

  constructor(private http: HttpClient, private userService: UserService) {
  }

  getCosts() {
    return this.http.get(this.url + 'costs');
  }

  getCost(id: number) {
    return this.http.get(this.url + 'cost/' + id).pipe(map(v => Cost.adapt(v)));
  }

  createCost(cost: Cost) {
    return this.http.post(this.url + 'cost', cost);
  }

  printCost(costs: number[]) {
    return this.http.post(this.url + 'cost/print', costs);
  }

  updateCost(cost: Cost, id) {
    return this.http.post(this.url + 'cost/' + id + '/update', cost);
  }

  fetchAdvanceCosts(id) {
    return this.http.get<Cost[]>(this.url + 'advance/' + id + '/costs');
  }

  fetchCostTypes() {
    return this.http.get(this.url + 'company/costTypes');
  }

  fetchAllCostsByStatus(status: string) {
    return this.http.get(this.url + 'employee/costs/' + status);
  }

  fetchRequireAttentionCosts() {
    return this.http.get(this.url + 'employee/assigned/costs');
  }

  fetchHistory(costId: number): Observable<CostHistory[]> {
    return this.http.get<CostHistory[]>(this.url + `cost/${costId}/history`);
  }

  fetchAllEmployeeCosts() {
    return this.http
      .get(
        this.url + 'employee/' + this.userService.getCurrentUserId() + '/costs'
      )
      .pipe(shareReplay());
  }

  fetchEmployeeCosts(employeeId: number) {
    return this.http
      .get(this.url + 'employee/' + employeeId + '/costs')
      .pipe
      // shareReplay()
      ();
  }

  // TODO: Remove first arg
  changeCostStatus(id: number, action: CostActions, params: Cost[]) {
    return this.http.post(`${this.url}cost/` + action, params);
  }

  sendForApproval(id: number) {
    return this.http.post(`${this.url}cost/` + id + '/sendForApproval', {});
  }

  fetchAttachments(id: number) {
    return this.http
      .get<Attachment[]>(`${this.url}cost/` + id + '/attachments')
      .pipe(map(v => v.map(Attachment.adapt)));
  }

  exportToCsv(costsId: Cost[]) {
    return this.http.post(`${this.url}cost/csv`, costsId, {responseType: 'blob'}).pipe(

    );
  }

  removeCost(id: number) {
    return this.http.post(`${this.url}cost/` + id + `/remove`, {});
  }

  fetch(
    id?: number,
    page?: number,
    limit?: number,
    options?: ApiDataOptions,
    sortDirection?: string,
    filter?: string
  ) {

    const params = new HttpParams()
      .set('filter', filter)
      .set('sortDirection', sortDirection)
      .set('page', page.toString())
      .set('limit', limit.toString());
    return this.http.get(this.url + 'employee/assigned/costs/' + (options.slug ? options.slug : ''), {params});
  }
}
